import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgChevronRightIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        d="m14.001 6.791 9.191 9.207-9.191 9.192-1.415-1.414 7.78-7.779-7.78-7.793z"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgChevronRightIcon;
